import { render, staticRenderFns } from "./carboxylgruppe.vue?vue&type=template&id=3c154962&"
import script from "./carboxylgruppe.vue?vue&type=script&lang=js&"
export * from "./carboxylgruppe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports